<template>
  <div v-loading="loading">
    <el-checkbox
      :indeterminate="isIndeterminate"
      v-model="checkAll"
      @change="handleCheckAllChange"
    >全选</el-checkbox>
    <div style="margin: 15px 0;"></div>
    <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
      <el-checkbox v-for="city in cities" :label="city.id" :key="city.id">{{city.name}}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  props: {
    getCourseWare: {
      type: Object,
      required: true
    },
    getCourse: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      checkAll: false,
      checkedCities: [],
      cities: [],
      isIndeterminate: false,
      // getCourseWare: {
      //   courseWareId: 6,
      //   schoolId: 8
      // },
      // getCourse: {
      //   schoolId: 8,
      //   teacherId: 6
      // }
    };
  },

  methods: {
    ngOnInit() {
      this.loading = true;
      this.$api.allianceSchool
        .getAnnounceVisibleList(this.getCourseWare)
        .then(res => {
          this.loading = false;
          this.checkedCities = [];
          if (res.errCode == 0) {
            res.data.forEach((item, idx) => {
              this.checkedCities.push(item.id);
            });
            this.isIndeterminate = this.checkedCities.length>0?true:false;
          } else {
            this.$message.error(res.errMsg);
          }
        }).catch(res=>{
        this.loading = false;
      });;
      this.$api.allianceSchool.getCourseSummaryList(this.getCourse).then(res => {
        if (res.errCode == 0) {
          this.cities = res.data;
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    // 课件列表
  coursewareInit() {
      this.loading = true;
      this.$api.allianceSchool
        .getCourseWareShareList(this.getCourseWare)
        .then(res => {
          this.loading = false;
          this.checkedCities = [];
          if (res.errCode == 0) {
            res.data.forEach((item, idx) => {
              this.checkedCities.push(item.id);
            });
            this.isIndeterminate = this.checkedCities.length>0?true:false;
          } else {
            this.$message.error(res.errMsg);
          }
        }).catch(res=>{
        this.loading = false;
      });;
      this.$api.allianceSchool.getCourseSummaryList(this.getCourse).then(res => {
        if (res.errCode == 0) {
          this.cities = res.data;
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    handleCheckAllChange(val) {
      if (val) {
        const param = [];
        this.cities.forEach((item, idx) => {
          param.push(item.id);
        });
        this.checkedCities = param;
      } else {
        this.checkedCities = [];
      }
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    }
  },
  created() {}
};
</script>
<style lang='less' scoped>
.action {
  margin-bottom: 20px;
}
.pagin {
  margin-top: 20px;
}
</style>